import React, { FC } from 'react';
import { connect } from 'react-redux';
import i18n from 'i18n-js';
import { Text, TransformsStyle, View } from 'react-native';

import ColorWrapper from '@styles/colors';
import Svg from '@styles/icons/svg';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import { machineStatus, machineStatusColorName, machineStatusName } from '@helpers';
import { transform } from 'terser-webpack-plugin/types/minify';

interface MachineStatusBadgeProps {
  separateTextAndIconForMobile?: boolean;
  onlyIcon?: boolean;
}

const MachineStatusBadge: FC<MachineStatusBadgeProps> = ({ selectedItem, C, separateTextAndIconForMobile, onlyIcon }) => {
  const status = selectedItem.machineStatus?.status;

  const config = {
    [machineStatus.ACTIVE]: {
      icon: 'activeMachine',
      width: 7,
      height: 18,
    },
    [machineStatus.CHANGE]: {
      icon: 'changeMachine',
      width: onlyIcon ? 18 : 14,
      height: 18,
    },
    [machineStatus.SETUP]: {
      icon: 'setupMachine',
      width: 10,
      height: 18,
    },
    [machineStatus.NOTPRODUCTIVE]: {
      icon: 'zzz',
      width: 9,
      height: 18,
    },
  };

  const currentConfig = config[status];

  if (!currentConfig) return null;

  const IconComponent = (
    <Svg
      icon={currentConfig.icon}
      width={scale(currentConfig.width)}
      height={scale(currentConfig.height)}
      color={C('Label/Light/AlwaysLight Primary')}
    />
  );

  if (separateTextAndIconForMobile) {
    return (
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          gap: scale(6),
        }}
      >
        <Text style={[font.Body, { color: C('Label/Light/Tertiary') }]}>{i18n.t(machineStatusName[status])}</Text>
        <View
          style={{
            justifyContent: 'center',
            alignItems: 'center',
            height: scale(24),
            width: scale(24),
            borderRadius: scale(20),
            backgroundColor: C(machineStatusColorName[status]),
            paddingVertical: scale(2.5),
            paddingHorizontal: scale(7),
          }}
        >
          {IconComponent}
        </View>
      </View>
    );
  }

  return (
    <View
      style={{
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: scale(4),
        height: scale(24),
        ...(onlyIcon ? { width: scale(24) } : {}),
        borderRadius: scale(20),
        backgroundColor: C(machineStatusColorName[status]),
        paddingVertical: scale(2.5),
        paddingHorizontal: scale(7),
      }}
    >
      {IconComponent}
      {!onlyIcon && (
        <Text style={[font.Footnote, { color: C('Label/Light/AlwaysLight Primary'), paddingBottom: scale(2) }]}>
          {i18n.t(machineStatusName[status])}
        </Text>
      )}
    </View>
  );
};

export default connect(({ machines: { selectedItem } }) => ({ selectedItem }), {})(ColorWrapper(MachineStatusBadge));
